import ReactMarkdown from 'react-markdown'
import { Box, styled } from '@mui/material'

import { DefaultElementProps } from 'common/interfaces'

import { MarkDown as MarkDownProps } from './interface'

const StyledDiv = styled(Box)({
  '& img': {
    maxWidth: '100%',
  },
})

const listItemPattern = /^\s*(?:[-*+]|\d+[.)])\s+/

function normalizeEscapedNewlines(markdown: string): string {
  return markdown.replace(/\\n/g, '\n')
}

function startsWithListItem(markdown: string): boolean {
  return listItemPattern.test(markdown.trimStart())
}

function joinMarkdownBlocks(markdown: string[]): string {
  return markdown.map(normalizeEscapedNewlines).reduce((acc, block) => {
    if (acc === '') {
      return block
    }

    const accLines = acc.split('\n')
    const lastLine = accLines[accLines.length - 1] ?? ''
    const separator = startsWithListItem(lastLine) && startsWithListItem(block)
      ? '\n'
      : '\n\n'

    return `${acc}${separator}${block}`
  }, '')
}

export default function MarkDown({
  markdown,
  style,
}: MarkDownProps & DefaultElementProps): JSX.Element {
  const stringWithCorrectNewline = Array.isArray(markdown)
    ? joinMarkdownBlocks(markdown)
    : normalizeEscapedNewlines(markdown)

  if (Array.isArray(markdown)) {
    return (
      <StyledDiv className="markdown-wrap" sx={style ?? {}}>
        <ReactMarkdown>{stringWithCorrectNewline}</ReactMarkdown>
      </StyledDiv>
    )
  }

  return (
    <StyledDiv className="markdown-wrap" sx={style ?? {}}>
      <ReactMarkdown>{stringWithCorrectNewline}</ReactMarkdown>
    </StyledDiv>
  )
}
